module.exports = __webpack_public_path__ + "img/Thumb_Lobstermania.49bf54e8.jpg";